<template>
  <div class="container" ref="wrapper">
    <!-- 大型号品类分布 -->
    <el-tabs type="border-card" v-model="activeName" style="border-radius:8px">
      <el-tab-pane label="大型号" name="a">
          <large-model :tableHeight="tableHeight" ></large-model>
      </el-tab-pane>
      <el-tab-pane label="产品" name="b">
        <product :tableHeight="tableHeight"></product>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import largeModel from "./common/largeModel.vue"
import product from "./common/product.vue"
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "lifeCycleManagement",
  // mixins: [importExportMxin, customProps],
  mixins: [pagePathMixin],
  components: {
    largeModel,
    product
  },
  data() {
    return {
      tableHeight: 0,
      activeName: 'a'
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.tableHeight = this.$refs["wrapper"].offsetHeight - 155;
  },
  methods: {
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 20px);
  box-sizing: border-box;
  border-radius: 5px;
}

.header-redio {
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

>>> .el-main {
  padding: 5px 8px 0px 16px;
  background: #ffffff;
  border-radius: 5px;
}

.header-text {
  color: #606266;
  padding: 10px 0px 0 0;
}

>>> ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

>>> .el-table__body-wrapper {
  z-index: 3 !important;
  position: relative !important;
}

>>> .el-form-item {
  margin-bottom:  0
}

// >>> .yearSelect .el-input__inner {
//   width: 130px;
//   height: 28px;
// }

 >>> .yearSelect .el-input {
   width: 100px !important
 }
 >>> .yearSelect {
   width: 100px !important
 }

 >>> .el-tabs--border-card>.el-tabs__header {
   border-radius: 8px
 }
>>> .el-tabs__nav-wrap{
  border-radius: 8px
}

 >>> .category .el-form-item__label {
   width: 45px !important
 }
</style>